import { PAGES, PAGES_HEADS } from "@/constants";
import { PAGES_AIDAR } from "@/constants/index_aidar";
import ImageUrl from "@/views/imageUrl";
import NotFound from "@/views/page404";
import Profile from "@/views/profile";
import InvalidObjects from "@/views/InvalidObjects";
import ResidentialSettings from "@/views/ResidentialSettings";
import PtoDocuments from "@/views/PtoDocuments/index.vue";
import PlanFactPaymentReport from "@/views/Reports/PlanFactPaymentReport.vue";
import ContractorSbsReport from "@/views/Reports/ContractorSbsReport.vue";
import ResourceRemainderReport from "@/views/Reports/ResourceRemainderReport.vue";
import OrderedVsM19Report from "@/views/Reports/OrderedVsM19Report.vue";
import ResourceStatementReport from "@/views/Reports/ResourceStatementReport.vue";
import PriceVarianceReport from "@/views/Reports/PriceVarianceReport.vue";
import OperFactBkCompareReport from "@/views/Reports/OperFactBkCompareReport.vue";
import UspNdsAvrYearReport from "@/views/Reports/UspNdsAvrYearReport.vue";
import ClosingDocuments from "@/views/ClosingDocuments/index.vue";
import BuildingSettings from "@/views/BuildingSettings";
import OpenSpaceLinks from "@/views/OpenSpaceLinks";
import ProjectsOverview from "@/views/ProjectsOverview";
import PackageEntry from "@/views/PackageEntry";
import PackageList from "@/views/PackageList";
import SbsProject from "@/views/sbsProject";
import SbsPartner from "@/views/sbsPartner";
import SbsCompany from "@/views/sbsCompany";
import { createRouter, createWebHistory } from "vue-router";
import ForgetPassword from "../views/ForgetPassword";
import Login from "../views/Login/index.vue";
import LoginKeycloakCallback from "../views/Login/LoginKeycloakCallback.vue";
import LoginUrl from "../views/loginUrl/index.vue";
import HomeView from "../views/Main/index.vue";
import ProjectsEntry from "@/views/ProjectsEntry";
import ProjectAgreementCancellations from "@/views/ProjectAgreementCancellations";
import ProjectBimSmetaHandbook from "@/views/ProjectsEntry/ProjectBimSmetaHandbook.vue";
import ProjectSmetaHubPage from "@/views/ProjectsEntry/ProjectSmetaHubPage.vue";
import ProjectAgreementComparePage from "@/views/ProjectsEntry/ProjectAgreementComparePage.vue";
import Materials from "@/views/Materials";
import BufferParams from "@/views/BufferParams";
import RevitBufferParams from "@/views/RevitBufferParams";
import FrameTypes from "@/views/Frames/Types";
import FramesList from "@/views/Frames/List";
import FloorParams from "@/views/FloorParams";
import ShellEstimates from "@/views/ShellEstimates";
import Contractors from "@/views/Contractors";
import Providers from "@/views/Providers";
import ProviderNcaKeys from "@/views/ProviderNcaKeys";
import BimCategories from "@/views/BimCategories";
import BimCategoryParams from "@/views/BimCategoryParams";
import ResidentDictionary from "@/views/ResidentDictionary/index.vue";
import ProjectTypeWarranties from "@/views/ProjectTypeWarranties";
import BimParams from "@/views/BimParams";
import BimSelectedParams from "@/views/BimSelectedParams";
import BimProjects from "@/views/BimProjects";
import BimRooms from "@/views/BimRooms";
import ProjectPatternStructure from "@/views/ProjectPatternStructure";
import ProjectPatternPeriodMatrix from "@/views/ProjectPatternPeriodMatrix";
import ResidentSmetaOverview from "@/views/ResidentSmetaOverview/index.vue";
import ResidentUspSmetaOverview from "@/views/ResidentUspSmetaOverview/index.vue";
import ResidentUspMaterialsNds from "@/views/ResidentUspMaterialsNds/index.vue";
import TierPlan from "@/views/TierPlan";
import TierFact from "@/views/TierFact";
import TierFactTimelineTier2to6 from "@/views/TierFactTimelineTier2to6";
import TierFactFirst from "@/views/TierFactFirst";
import TierReasonReport from "@/views/TierReasonReport";
import TierDaily from "@/views/TierDaily";
import Constructives from "@/views/Constructives";
import CheckLists from "@/views/CheckLists";
import WorkChecks from "@/views/WorkChecks";
import TierBlocks from "@/views/TierBlocks";
import ContractorAgreementList from "@/views/ContractorAgreementList";
import ProviderAgreementList from "@/views/ProviderAgreementList";
import TierWorkGroup from "@/views/TierWorkGroup";
import TierReason from "@/views/TierReason";
import JobQueueMonitor from "@/views/JobQueueMonitor";
import DocumentQueueMonitor from "@/views/DocumentQueueMonitor";
import TradingHouse from "@/views/TradingHouse";
import SupplierRequests from "@/views/SupplierRequests";
import SupplierRequestsFromRequired from "@/views/SupplierRequestsFromRequired";
import InvoiceApprovals from "@/views/InvoiceApprovals";
import InvoiceApprovalConfig from "@/views/InvoiceApprovalConfig";
import FinancePaymentCreateForMaster from "@/views/FinancePaymentCreateForMaster";
import FinancePaymentExcludeProjects from "@/views/FinancePaymentExcludeProjects";
import Handbook from "@/views/handbook";
import { handbookTitles } from "@/views/handbook/services";
import AvrSetting from "@/views/AvrSetting";
import UnsignedSign from "@/views/UnsignedSign";
import SmetaChangeLog from "@/views/SmetaChangeLog";
import ForemanWorkAcceptance from "@/views/ForemanWorkAcceptance";
import EmployeeTasks from "@/views/EmployeeTasks";
import Acceptance from "@/views/Acceptance";
import ContractsDictionary from "@/views/ContractsDictionary";
import MaterialsOverspend from "@/views/MaterialsOverspend/index.vue";
import Required from "@/views/Required";
import RequiredItems from "@/views/Required/RequiredItems.vue";
import RequiredTypes from "@/views/RequiredTypes";
import RequiredSupplier from "@/views/RequiredSupplier";
import RequiredItemsSupplier from "@/views/RequiredSupplier/RequiredItemsSupplier.vue";
import RequiredSupply from "@/views/RequiredSupply";
import WorkCheckBpmn from "@/views/WorkCheckBpmn/index.vue";
import WorkCheckBpmnInstancesPage from "@/views/WorkCheckBpmn/WorkCheckBpmnInstancesPage.vue";
import WorkCheckBpmnInstance from "@/views/WorkCheckBpmn/BpmnInstancePage.vue";

export const routes = [
  {
    path: PAGES.login,
    name: "login",
    meta: { layout: "empty", title: "Авторизация" },
    component: Login,
  },
  {
    path: PAGES.forgetPassword,
    name: "forgetPassword",
    meta: { layout: "empty", title: "Забыли пароль" },
    component: ForgetPassword,
  },
  {
    path: PAGES.loginKeycloakCallback,
    name: "loginKeycloakCallback",
    meta: { layout: "empty", title: "Вход BI Group" },
    component: LoginKeycloakCallback,
  },
  {
    path: PAGES.main,
    name: "main",
    meta: { layout: "main" },
    component: HomeView,
  },
  {
    path: PAGES.profile,
    name: "profile",
    meta: { layout: "main", title: "Профиль" },
    component: Profile,
  },
  {
    path: PAGES.invalidObjects,
    name: "invalidObjects",
    meta: { layout: "main", title: "Инвалидные объекты" },
    component: InvalidObjects,
  },
  {
    path: PAGES.loginUrl,
    name: "loginUrl",
    meta: { layout: "check", routeHead: PAGES_HEADS.loginUrl },
    component: LoginUrl,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    params: { pathMatch: ["not", "found"] },
    meta: { layout: "main", title: "Не найдено" },
    component: NotFound,
  },
  {
    path: PAGES.residentialSettings,
    name: "residentialSettings",
    meta: {
      layout: "main",
      padding: false,
      title: "Настройка жилого комплекса",
    },
    component: ResidentialSettings,
  },
  {
    path: PAGES.ptoDocuments,
    name: "ptoDocuments",
    meta: {
      layout: "main",
      padding: false,
      title: "Документы ПТО",
    },
    component: PtoDocuments,
  },
  {
    path: PAGES.reportsPlanFactPayment,
    name: "reportsPlanFactPayment",
    meta: {
      layout: "main",
      title: "Сверка план-факт и платеж",
    },
    component: PlanFactPaymentReport,
  },
  {
    path: PAGES.reportsContractorSbs,
    name: "reportsContractorSbs",
    meta: {
      layout: "main",
      title: "Финансовый отчёт",
    },
    component: ContractorSbsReport,
  },
  {
    path: PAGES.reportsResourceStatement,
    name: "reportsResourceStatement",
    meta: {
      layout: "main",
      title: "Ведомость ресурсов",
    },
    component: ResourceStatementReport,
  },
  {
    path: PAGES.reportsOperFactBkCompare,
    name: "reportsOperFactBkCompare",
    meta: {
      layout: "main",
      title: "Сверка SBS, факт и бухгалтерия",
    },
    component: OperFactBkCompareReport,
  },
  {
    path: PAGES.reportsUspNdsAvrYear,
    name: "reportsUspNdsAvrYear",
    meta: {
      layout: "main",
      title: "УСП: НДС по году АВР",
    },
    component: UspNdsAvrYearReport,
  },
  {
    path: PAGES.reportsResourceRemainder,
    name: "reportsResourceRemainder",
    meta: {
      layout: "main",
      title: "Остаток ТМЦ на ЖЦП",
    },
    component: ResourceRemainderReport,
  },
  {
    path: PAGES.reportsOrderedVsM19,
    name: "reportsOrderedVsM19",
    meta: {
      layout: "main",
      title: "Смета, заказ и списание М-19",
    },
    component: OrderedVsM19Report,
  },
  {
    path: PAGES.reportsPriceVariance,
    name: "reportsPriceVariance",
    meta: {
      layout: "main",
      title: "Расхождение цен",
    },
    component: PriceVarianceReport,
  },
  {
    path: PAGES.buildingSettings,
    name: "buildingSettings",
    meta: {
      layout: "main",
      padding: false,
      title: "Настройка жилого комплекса",
    },
    component: BuildingSettings,
  },
  {
    path: PAGES.openSpaceLinks,
    name: "openSpaceLinks",
    meta: {
      layout: "main",
      title: "Ссылки Open Space",
    },
    component: OpenSpaceLinks,
  },
  {
    path: PAGES.projectsOverview,
    name: "projectsOverview",
    meta: {
      layout: "main",
      title: "Сводная по проектам",
    },
    component: ProjectsOverview,
  },
  {
    path: PAGES.packageEntry,
    name: "packageEntry",
    meta: {
      layout: "main",
      title: "Комплектация",
    },
    component: PackageEntry,
  },
  {
    path: PAGES.imageUrl,
    name: "imageUrl",
    meta: { layout: "empty", title: "Изображение" },
    component: ImageUrl,
  },
  {
    path: PAGES.sbsProject,
    name: "sbsProject",
    meta: { layout: "main", title: "SBS проекты" },
    component: SbsProject,
  },
  {
    path: PAGES.sbsPartner,
    name: "sbsPartner",
    meta: { layout: "main", title: "SBS партнеры" },
    component: SbsPartner,
  },
  {
    path: PAGES.sbsCompany,
    name: "sbsCompany",
    meta: { layout: "main", title: "SBS компании" },
    component: SbsCompany,
  },
  {
    path: PAGES.projectsEntry,
    name: "projectsEntry",
    meta: { layout: "main", title: "Проекты" },
    component: ProjectsEntry,
  },
  {
    path: PAGES.projectAgreementCancellations,
    name: "projectAgreementCancellations",
    meta: { layout: "main", title: "Сторно договора в УСП" },
    component: ProjectAgreementCancellations,
  },
  {
    path: PAGES.projectsEntryBimSmeta,
    name: "projectBimSmetaHandbook",
    meta: { layout: "main", title: "BIM-смета" },
    component: ProjectBimSmetaHandbook,
  },
  {
    path: PAGES.projectSmetaHub,
    name: "projectSmetaHub",
    meta: { layout: "main", title: "Смета проекта" },
    component: ProjectSmetaHubPage,
  },
  {
    path: PAGES.projectAgreementCompare,
    name: "projectAgreementCompare",
    meta: { layout: "main", title: "Сравнение договоров" },
    component: ProjectAgreementComparePage,
  },
  {
    path: PAGES.packageList,
    name: "packageList",
    meta: { layout: "main", title: "Наборы" },
    component: PackageList,
  },
  {
    path: PAGES.materials,
    name: "Materials",
    meta: { layout: "main", title: "Материалы" },
    component: Materials,
  },
  {
    path: PAGES.floorParams,
    name: "floorParams",
    meta: { layout: "main", title: "Параметры этажей" },
    component: FloorParams,
  },
  {
    path: PAGES.shellEstimates,
    name: "shellEstimates",
    meta: { layout: "main", title: "Смета по черновой" },
    component: ShellEstimates,
  },
  {
    path: PAGES.frameTypes,
    name: "frameTypes",
    meta: { layout: "main", title: "Настройка параметров типа конструкции" },
    component: FrameTypes,
  },
  {
    path: PAGES.framesList,
    name: "framesList",
    meta: { layout: "main", title: "Настройка параметров типа конструкции" },
    component: FramesList,
  },
  {
    path: PAGES.bufferParams,
    name: "bufferParams",
    meta: { layout: "main", title: "Данные с буффера" },
    component: BufferParams,
  },
  {
    path: PAGES.revitBufferParams,
    name: "revitBufferParams",
    meta: { layout: "main", title: "Данные с ревит буффера" },
    component: RevitBufferParams,
  },
  {
    path: PAGES.contractors,
    name: "contractors",
    meta: { layout: "main", title: "Подрядчики" },
    component: Contractors,
  },
  {
    path: PAGES.providers,
    name: "providers",
    meta: { layout: "main", title: "Поставщики" },
    component: Providers,
  },
  {
    path: PAGES.providerNcaKeys,
    name: "providerNcaKeys",
    meta: { layout: "main", title: "ЭЦП-ключи поставщиков" },
    component: ProviderNcaKeys,
  },
  {
    path: PAGES.projectTypeWarranties,
    name: "projectTypeWarranties",
    meta: { layout: "main", title: "Процент гарантии" },
    component: ProjectTypeWarranties,
  },
  {
    path: PAGES.bimCategories,
    name: "bimCategories",
    meta: { layout: "main", title: "БИМ Категории" },
    component: BimCategories,
  },
  {
    path: PAGES.bimCategoryParams,
    name: "bimCategoryParams",
    meta: { layout: "main", title: "БИМ Параметры категорий" },
    component: BimCategoryParams,
  },
  {
    path: PAGES.residentDictionary,
    name: "residentDictionary",
    meta: { layout: "main", title: "Справочник ЖК" },
    component: ResidentDictionary,
  },
  {
    path: PAGES.bimParams,
    name: "bimParams",
    meta: { layout: "main", title: "БИМ Параметры" },
    component: BimParams,
  },
  {
    path: PAGES.bimSelectedParams,
    name: "bimSelectedParams",
    meta: { layout: "main", title: "Выбранные БИМ Параметры" },
    component: BimSelectedParams,
  },
  {
    path: PAGES.bimProjects,
    name: "bimProjects",
    meta: { layout: "main", title: "БИМ Проекты" },
    component: BimProjects,
  },
  {
    path: PAGES.bimRooms,
    name: "bimRooms",
    meta: { layout: "main", title: "Комнаты BIM" },
    component: BimRooms,
  },
  {
    path: PAGES.projectPatternStructure,
    name: "projectPatternStructure",
    meta: { layout: "main", title: "Структура УСП проекта" },
    component: ProjectPatternStructure,
  },
  {
    path: PAGES.projectPatternPeriodMatrix,
    name: "projectPatternPeriodMatrix",
    meta: { layout: "main", title: "Матрица периода УСП" },
    component: ProjectPatternPeriodMatrix,
  },
  {
    path: PAGES.residentSmetaOverview,
    name: "residentSmetaOverview",
    meta: { layout: "main", title: "Отчет Бюджет проекта" },
    component: ResidentSmetaOverview,
  },
  {
    path: PAGES.residentUspSmetaOverview,
    name: "residentUspSmetaOverview",
    meta: { layout: "main", title: "Отчет Бюджет проекта (структура УСП)" },
    component: ResidentUspSmetaOverview,
  },
  {
    path: PAGES.residentUspMaterialsNds,
    name: "residentUspMaterialsNds",
    meta: { layout: "main", title: "НДС в материалах УСП" },
    component: ResidentUspMaterialsNds,
  },
  {
    path: PAGES.tierPlan,
    name: "tierPlan",
    meta: { layout: "main", title: "План работ" },
    component: TierPlan,
  },
  {
    path: PAGES.tierFact,
    name: "tierFact",
    meta: { layout: "main", title: "Факт работ" },
    component: TierFact,
  },
  {
    path: PAGES.tierFactTimelineTier2to6,
    name: "tierFactTimelineTier2to6",
    meta: { layout: "main", title: "Tier 2-6" },
    component: TierFactTimelineTier2to6,
  },
  {
    path: PAGES_AIDAR.tierFactFirst,
    name: "tierFactFirst",
    meta: { layout: "main", title: "План-Факт (Первый)" },
    component: TierFactFirst,
  },
  {
    path: PAGES_AIDAR.tierReasonReport,
    name: "tierReasonReport",
    meta: { layout: "main", title: "Отчет по причинам отставания" },
    component: TierReasonReport,
  },
  {
    path: PAGES.tierDaily,
    name: "tierDaily",
    meta: { layout: "main", title: "Ежедневные работы" },
    component: TierDaily,
  },
  {
    path: PAGES.constructives,
    name: "constructives",
    meta: { layout: "main", title: "Конструктивы" },
    component: Constructives,
  },
  {
    path: PAGES.checkLists,
    name: "checkLists",
    meta: { layout: "main", title: "Чек-листы" },
    component: CheckLists,
  },
  {
    path: PAGES.workChecks,
    name: "workChecks",
    meta: { layout: "main", title: "Связи чек-листов" },
    component: WorkChecks,
  },
  {
    path: PAGES.tierblocks,
    name: "tierblocks",
    meta: { layout: "main", title: "Tier блоки" },
    component: TierBlocks,
  },
  {
    path: PAGES.contractorAgreementList,
    name: "contractorAgreementList",
    meta: { layout: "main", title: "Список договоров поставок" },
    component: ContractorAgreementList,
  },
  {
    path: PAGES.providerAgreementList,
    name: "providerAgreementList",
    meta: { layout: "main", title: "Договоры поставок (для поставщиков)" },
    component: ProviderAgreementList,
  },
  {
    path: PAGES.tierWorkGroup,
    name: "tierWorkGroup",
    meta: { layout: "main", title: "Группы работ и задачи" },
    component: TierWorkGroup,
  },
  {
    path: PAGES.tierReason,
    name: "tierReason",
    meta: { layout: "main", title: "Причины невыполнения" },
    component: TierReason,
  },
  {
    path: PAGES.jobQueueMonitor,
    name: "jobQueueMonitor",
    meta: { layout: "main", title: "Мониторинг очереди задач" },
    component: JobQueueMonitor,
  },
  {
    path: PAGES.documentQueueMonitor,
    name: "documentQueueMonitor",
    meta: { layout: "main", title: "Исполнительные листы — очередь формирования" },
    component: DocumentQueueMonitor,
  },
  {
    path: PAGES.handbook,
    name: "handbook",
    meta: {
      layout: "main",
      defaultTitle: "Справочник",
      withParamType: true,
      titles: handbookTitles,
    },
    component: Handbook,
  },
  {
    path: PAGES.tradingHouse,
    name: "tradingHouse",
    meta: { layout: "main", title: "Сводная по торговым домам" },
    component: TradingHouse,
  },
  {
    path: PAGES.supplierRequests,
    name: "supplierRequests",
    meta: { layout: "main", title: "Заявки поставщикам" },
    component: SupplierRequests,
  },
  {
    path: PAGES.supplierRequestsFromRequired,
    name: "supplierRequestsFromRequired",
    meta: { layout: "main", title: "Заявки снабженца" },
    component: SupplierRequestsFromRequired,
  },
  {
    path: PAGES.invoiceApprovals,
    name: "invoiceApprovals",
    meta: { layout: "main", title: "Утверждение накладных" },
    component: InvoiceApprovals,
  },
  {
    path: PAGES.invoiceApprovalConfig,
    name: "invoiceApprovalConfig",
    meta: { layout: "main", title: "Настройки утверждения накладных" },
    component: InvoiceApprovalConfig,
  },
  {
    path: PAGES.financePaymentCreateForMaster,
    name: "financePaymentCreateForMaster",
    meta: { layout: "main", title: "Оплаты подрядчикам (через master)" },
    component: FinancePaymentCreateForMaster,
  },
  {
    path: PAGES.financePaymentExcludeProjects,
    name: "financePaymentExcludeProjects",
    meta: { layout: "main", title: "Исключение проектов от оплат" },
    component: FinancePaymentExcludeProjects,
  },
  {
    path: PAGES.avrSetting,
    name: "avrSetting",
    meta: { layout: "main", title: "Настройка АВР по конструктивам" },
    component: AvrSetting,
  },
  {
    path: PAGES.unsignedSign,
    name: "unsignedSign",
    meta: { layout: "main", title: "Неподписанные ЭЦП документы" },
    component: UnsignedSign,
  },
  {
    path: PAGES.smetaChangeLog,
    name: "smetaChangeLog",
    meta: { layout: "main", title: "Журнал изменений сметы" },
    component: SmetaChangeLog,
  },
  {
    path: PAGES.foremanWorkAcceptance,
    name: "foremanWorkAcceptance",
    meta: { layout: "main", title: "Принятие работ НУ" },
    component: ForemanWorkAcceptance,
  },
  {
    path: PAGES.employeeTasks,
    name: "employeeTasks",
    meta: { layout: "main", title: "Мои задачи" },
    component: EmployeeTasks,
  },
  {
    path: PAGES.acceptance,
    name: "acceptance",
    meta: { layout: "main", title: "Шаги приёмки" },
    component: Acceptance,
  },
  {
    path: PAGES.geodesistCalls,
    name: "geodesistCalls",
    redirect: () => ({ path: PAGES.residentialSettings, query: { tab: "M__ProjectFormGeodesistCallTab" } }),
  },
  {
    path: PAGES.contractsDictionary,
    name: "contractsDictionary",
    meta: { layout: "main", title: "Справочник договоров" },
    component: ContractsDictionary,
  },
  {
    path: PAGES.materialsOverspend,
    name: "materialsOverspend",
    meta: { layout: "main", title: "Перерасход материалов" },
    component: MaterialsOverspend,
  },
  {
    path: PAGES.requiredTypes,
    name: "requiredTypes",
    meta: { layout: "main", title: "Типы потребностей материалов" },
    component: RequiredTypes,
  },
  {
    path: PAGES.required,
    name: "required",
    meta: { layout: "main", title: "Мои потребности в материалах" },
    component: Required,
  },
  {
    path: PAGES.requiredItems,
    name: "requiredItems",
    meta: { layout: "main", title: "Детали потребности" },
    component: RequiredItems,
    props: true,
  },
  {
    path: PAGES.requiredSupplier,
    name: "requiredSupplier",
    meta: { layout: "main", title: "Потребности в материалах (поставщик)" },
    component: RequiredSupplier,
  },
  {
    path: PAGES.requiredItemsSupplier,
    name: "requiredItemsSupplier",
    meta: { layout: "main", title: "Детали потребности (поставщик)" },
    component: RequiredItemsSupplier,
    props: true,
  },
  {
    path: PAGES.requiredSupply,
    name: "requiredSupply",
    meta: { layout: "main", title: "Потребности по проекту (поставщик)" },
    component: RequiredSupply,
  },
  {
    path: PAGES.workCheckBpmn,
    name: "workCheckBpmn",
    meta: { layout: "main", title: "BPMN — Схемы приёмки" },
    component: WorkCheckBpmn,
  },
  {
    path: PAGES.workCheckBpmnInstances,
    name: "workCheckBpmnInstances",
    meta: { layout: "main", title: "BPMN — Активные процессы" },
    component: WorkCheckBpmnInstancesPage,
  },
  {
    path: PAGES.workCheckBpmnInstance,
    name: "workCheckBpmnInstance",
    meta: { layout: "main", title: "BPMN — Процесс" },
    component: WorkCheckBpmnInstance,
  },
  {
    path: PAGES.closingDocuments,
    name: "closingDocuments",
    meta: { layout: "main", title: "Закрывающие документы" },
    component: ClosingDocuments,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  let title = to?.meta?.title
    ? `${to?.meta?.title} | Smart Build System`
    : "Smart Build System";
  try {
    if ((to.meta?.withParam || to?.meta?.withParamType) && to?.params) {
      const paramsKeys = Object.keys(to?.params);
      if (paramsKeys?.length)
        title = `${to.meta?.title ? `${to.meta?.title} ` : ""}${
          to?.meta?.withParamType ? "" : "#"
        }${
          to?.meta?.withParamType
            ? to.meta?.titles[to?.params[paramsKeys[0]]] ||
              to.meta?.defaultTitle ||
              ""
            : to?.params[paramsKeys[0]]
        } | Smart Build System`;
    }
  } catch (e) {}
  document.title = title;
  next();
});

export default router;
export const notInitRoutes = routes
  .filter((item) => item.meta?.layout === "check" && !!item.meta?.routeHead)
  ?.map((item) => item.meta?.routeHead);
